import { RootState } from 'store/rootReducer';
import { selectorsFactory } from 'store/entities/utils';

export const organizationTypesSlice = (state: RootState) => state.entities.adminOrganizationTypes;

export const organizationTypes = selectorsFactory.createStaticKeyWindowEntitiesMemoizedSelector(organizationTypesSlice);

export const organizationTypesState =
  selectorsFactory.createStaticKeyWindowStateMemoizedSelector(organizationTypesSlice);
